import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { sharedBaseCardsStyles, sharedHoverCardsStyles } from '../../sharedStyles/cardsStyles';

const bottomCaptionCardBorderRadius = ({ theme }) => `
  border-radius: ${theme.DS_border.radius.highlighted};
`;

export const StyledCardImage = styled('div')(
  ({ $illustrated }) => `
    height: 100%;
    transform: ${$illustrated ? 'scale(0.7)' : 'none'};
  `,
);

export const StyledBottomCaptionCard = styled('div')(
  ({ theme }) => `
    height: 100%;
    overflow: hidden;
    position: relative;
    ${sharedBaseCardsStyles({ theme })};
    ${bottomCaptionCardBorderRadius({ theme })};
    border: none;
    :hover {
      ${sharedHoverCardsStyles({ theme })};
    }
    
   ${theme.breakpoints.up('md')} {
       border-radius: ${theme.DS_border.radius.priceCard};
    }
  `,
);

export const StyledCaption = styled(Typography)(
  ({ theme, $illustrated }) => `
    box-sizing: border-box;
    color: ${theme.DS_palette.primary.black};
    background-color: ${$illustrated ? '#fafbff' : theme.DS_palette.primary.white};
    position: absolute;
    text-align: center;
    width: calc(100% - 8px);
    bottom: 4px;
  
    z-index: 3;
    border-radius: 8px;
    padding: 3px;
    left: 50%;
    transform: translateX(-50%); 
    min-height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
 
    ${theme.breakpoints.up('md')} {
     width: calc(100% - 24px);
      bottom: 12px;
      padding: ${theme.DS_spacing(['sm'])} 2px;
     ${bottomCaptionCardBorderRadius({ theme })};
    }
    
 

  `,
);

export const StyledGradientEffect = styled('div')(
  ({ theme }) => `
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 64.58%, rgba(0, 0, 0, 0.2) 100%), 50% / cover no-repeat;
    box-shadow: 5px 17px 32px 0px rgba(0, 0, 0, 0.07);
    z-index: 2;
    ${bottomCaptionCardBorderRadius({ theme })};
  `,
);

export const StyledResponsiveImage = styled('div')(
  ({ $illustrated }) => `
    display: ${$illustrated ? 'block' : 'flex'};
    height: 100%;
    z-index: 1;
    transform: ${$illustrated ? 'scale(0.7)' : 'none'};
    
  `,
);
